import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import api from "../api/api";
import useUrlQuery from "../hooks/useUrlQuery";
import { Actions } from "../slices/actions";

export const useGetUserDetails = () => {
  const { getQuery } = useUrlQuery();
  const enquiry_id = getQuery("enquiry_id");
  const { data, isLoading, refetch } = useQuery(
    ["Details", enquiry_id],
    () => api.get(`/get/enquiry/details?enquiry_id=${enquiry_id}`),
    {
      enabled: !!enquiry_id,
      onSuccess: (data) => {
        Actions.setLeadData({
          ...data.data.data[0],
          country_name: data.data.data[0].travelling_to_country_name,
          travelling_to: data.data.data[0].travelling_to_country_id,
        });
        if (data.data.data[0].sum_insured)
          Actions.setSumInsurer(data.data.data[0].sum_insured);
        if (data.data.data[0].proposal_data) {
          Actions.setProposalData(data.data.data[0].proposal_data.data);
        }
        if (data.data.data[0].primary_proposer_id) {
          Actions.setPrimaryProposerId(data.data.data[0].primary_proposer_id);
        }
        const plan_type = data.data.data[0].plan_type;
        const travel_purpose_id = data.data.data[0].travel_purpose_id;

        if (plan_type === "Indivdual") {
          if (travel_purpose_id === "1" || travel_purpose_id === 1) {
            Actions.setPlanType("Individual Plan");
          }
          if (travel_purpose_id === "4" || travel_purpose_id === 4) {
            Actions.setPlanType("Student Plan");
          }
        }
        if (plan_type === "Floater") {
          Actions.setPlanType("Family Plan");
        }
        const members = [];

        if (
          data.data.data[0].proposer_age != null &&
          data.data.data[0].proposer_age
        ) {
          members?.push({ label: "Self", value: "self" });
        }
        if (
          data.data.data[0].members_age_detail?.spouse_age != null &&
          data.data.data[0].members_age_detail?.spouse_age
        ) {
          members?.push({ label: "Spouse", value: "spouse" });
        }
        if (
          data.data.data[0].members_age_detail?.child_1_age != null &&
          data.data.data[0].members_age_detail?.child_1_age >= 0
        ) {
          members?.push({ label: "Child 1", value: "child_1" });
        }
        if (
          data.data.data[0].members_age_detail?.child_2_age != null &&
          data.data.data[0].members_age_detail?.child_2_age >= 0
        ) {
          members?.push({ label: "Child 2", value: "child_2" });
        }
        if (
          data.data.data[0].members_age_detail?.parent_1_age != null &&
          data.data.data[0].members_age_detail?.parent_1_age
        ) {
          members?.push({ label: "Parent 1", value: "parent_1" });
        }
        if (
          data.data.data[0].members_age_detail?.parent_2_age != null &&
          data.data.data[0].members_age_detail?.parent_2_age
        ) {
          members?.push({ label: "Parent 2", value: "parent_2" });
        }

        Actions.setProposalMembers(members);
      },
    }
  );
  return {
    userDetails: { ...data?.data?.data[0] },
    country: data?.data?.data[0]?.travelling_to_country_name,
    members: data?.data?.data[0]?.no_of_travellers,
    data: data?.data?.data[0],
    isDetailsLoading: isLoading,
    refetchUserDetails: refetch,
  };
};
export const useCommunication = () => {
  const { getQuery } = useUrlQuery();
  const enquiry_id = getQuery("enquiry_id");
  const { mutate, isLoading } = useMutation(
    (req) => api.post("/quotes/travel/shareCQ", { ...req, enquiry_id }),
    {
      onSuccess: (variables) => {
        toast.success(
          <div style={{ fontSize: ".8rem", fontWeight: "600" }}>
            {variables?.data?.message || "Shared Successfully"} !!
          </div>
        );
      },
    }
  );

  return { share: mutate, isShareLoading: isLoading };
};
